/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

function DarkFooter() {
  return (
    <footer className="footer" data-background-color="black">
      <Container>
        <nav>
          <ul>
            <li>
              <a
                href="/terms.html"
                target=""
              >
                Terms and Conditions
              </a>
            </li>
          </ul>
        </nav>
        <div className="copyright" id="copyright">
          © {new Date().getFullYear()}, Designed by{" "}
            <a
              href="" rel="noreferrer"

            >
              Invision
            </a>{" & "}
            <a
            href="/index"
            target=""
          >
            XPATSO
          </a>
            . Coded by{" "}
            <a
              href="" rel="noreferrer"
            >
              Creative Tim
            </a>{" & "}
          <a
            href=""
            target=""
          >
            XPATSO
          </a>
          .
        </div>
      </Container>
    </footer>
  );
}

export default DarkFooter;
